App.SmToggleComponent = Em.Checkbox.extend
  classNames: [ 'sm-toggle' ]

  classNameBindings: [ 'disabled' ]

  sendChangeEvent: (->
    if @get('onChange') and @get('parentContext')
      @get('parentContext').send(@get('onChange'), @get('checked'))
  ).on('click')